import * as Yup from "yup";
import { forceInt } from "Utils";
import { fromSqlDateTime } from "helpers/Date";
import { transform as assignmentTransformer } from "./Assignment";
import { transform as contentTransformer } from "./Content";

export const IssueValidationSchema = Yup.object().shape({});

export const IssueObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    label: null,
    decorated_label: null,
    description: null,
    status: null,
    created_at: null,
    modified_at: null,
    published_at: null,
    assignments: [],
    content: [],
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let issue = Object.assign({}, IssueObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        label: requestData.label,
        decorated_label: requestData.decorated_label,
        description: requestData.description,
        status: requestData.status,
        created_at: fromSqlDateTime(requestData.created_at),
        modified_at: fromSqlDateTime(requestData.modified_at),
        published_at: fromSqlDateTime(requestData.published_at),
    });

    if (requestData.assignments) {
        let assignments = assignmentTransformer(requestData.assignments);
        issue = Object.assign({}, issue, { assignments: assignments });
    }

    if (requestData.content) {
        let content = contentTransformer(requestData.content);
        issue = Object.assign({}, issue, { content: content });
    }

    return issue;
}
